__turbopack_context__.v({
  "animating": "styles-module__MFJUoq__animating",
  "media": "styles-module__MFJUoq__media",
  "picture": "styles-module__MFJUoq__picture",
});
